import { Button, Text } from "@sundae/ui-toolkit";
import { ReactLocation, Router, createHashHistory } from "@tanstack/react-location";
import { FC, lazy } from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import Providers from "./Providers";
import ErrorFallback from "./components/ErrorFallback";
import MainLayout from "./layouts/MainLayout";
import { AppRoutes } from "./pages/routes";

const Dialogs = lazy(() => import("./Dialogs").then((m) => ({ default: m.Dialogs })));

import "./i18n";

const history = createHashHistory({});

const location = new ReactLocation({ history });

const FallbackComponent: FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
  return (
    <div className="grid gap-2 p-2" role="alert">
      <Text tag="div" size="lg">
        Something went wrong:
      </Text>
      <Text tag="div">{error.message}</Text>
      <Button onClick={resetErrorBoundary} className="w-fit">
        Try again
      </Button>
    </div>
  );
};

const LazyReactLocationDevTools =
  process.env.NODE_ENV === "development"
    ? lazy(() =>
        import("@tanstack/react-location-devtools").then((m) => ({
          default: m.ReactLocationDevtools,
        }))
      )
    : () => null as JSX.Element;

export const App: FC = () => {
  return (
    <Providers>
      <ErrorBoundary
        FallbackComponent={(props) => (
          <ErrorBoundary FallbackComponent={FallbackComponent}>
            <ErrorFallback {...props} />
          </ErrorBoundary>
        )}
      >
        <Router useErrorBoundary location={location} routes={AppRoutes}>
          <Dialogs />
          <MainLayout />
          <LazyReactLocationDevTools position="bottom-right" initialIsOpen={false} />
        </Router>
      </ErrorBoundary>
    </Providers>
  );
};

export default App;
